import { withChartLayout } from 'components/common';
import IntegumentaryAssessment from 'components/features/chart/system-assessment/integumentary-assessment/IntegumentaryAssessment';

const IntegumentaryAssessmentPage = withChartLayout('Integumentary Assessment')(IntegumentaryAssessment);
export default IntegumentaryAssessmentPage;
